export const API_REQ_PARAM_CONSTANTS = {
  // Module id
  MODULE_ID: '1',
  LANGUAGE_EN_ID: '1',

  // Group cat id's
  GROUP_CAT_ID_SHOWS: '1',
  GROUP_CAT_ID_MOVIES: '2',
  GROUP_CAT_ID_MYBB: '3',
  GROUP_CAT_ID_EVENT: '4',

  // Main cat id's
  TV_SHOW_ORIGINAL_CAT_ID: '1',
  TV_SHOW_GLOBAL_CAT_ID: '2',
  TV_SHOW_TODDLERS_CAT_ID: '3',
  TV_SHOW_EDUTAINMENT_CAT_ID: '4',
  MOVIES_GLOBAL_CAT_ID: '5',

  // Section id's
  SECTION_POPULAR_ID: '1',
  SECTION_TOPPICKS_ID: '2',
  SECTION_RECENNTLY_ADDED_ID: '3',
  SECTION_TODAYS_SPCL_ID: '4',
  SECTION_CONTINUE_WATCHING_ID: '5',
  SECTION_RECOMENDED_ID: '6',
  SECTION_SIMILAR_ID: '7',
  SECTION_HOME_ID: '8',

  HOME_BANNER_SEASONS: '0',
  // Season 1
  TV_SHOW_TRAILER: '0',
  TV_SHOW_SEASON_ONE: '1',

  // Notification types
  ARTICLE: 'article',
  DIRECT: 'direct',

  // watched list api type constants
  CONTINUE_WATCHING: 'continue',
  WATCH_HISTORY: 'total',

  // feedback api type constants
  FEEDBACK_FEEDBACK: 'feedback',
  FEEDBACK_FAQ: 'faq',

  // Paintathon result api type constant 
  // PAINTATHON_YEAR_2021: '2021',
  // PAINTATHON_YEAR_2023: '2023',
  // PAINTATHON_YEAR_2024: '2024',

};
